module.exports = __webpack_public_path__ + "book.png?fddad1489639f8b7052803bc4f4b2c57";